export default __webpack_public_path__ + "static/media/c2a6b71636055cb81fd0d332b26342ef.gif";